import { useEffect } from 'react';
import './Patent.css'
import Header from './Header';
import Footer from './Footer';
import AOS from "aos";
import { Link } from 'react-router-dom';
import "aos/dist/aos.css";

const Patents = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <>
            <Header />
            <section className="patents-hero section-container">
                <div className="hero-background"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>

                <div className="content-container">
                    <div className="hero-content">
                        <h1 className="hero-title" data-aos="fade-up">
                            Patented Technology
                        </h1>

                        <p
                            className="hero-subtitle"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            The Foundation of Modern Mobile Marketing
                        </p>

                        <div
                            className="hero-tagline"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            <i className="fas fa-lightbulb"></i>
                            Revolutionizing Advertising with Proprietary Technology
                        </div>
                    </div>
                </div>
            </section>
            {/* Introduction Section  */}
            <section className="intro-section section-container">
                <div className="content-container">
                    <div className="section-header" data-aos="fade-up">
                        <h2>The Technology That Powers Mobile Advertising</h2>
                        <p>
                            Foundational patents that enabled the $75 billion mobile advertising
                            industry
                        </p>
                    </div>

                    <div className="intro-content">
                        <div className="intro-text" data-aos="fade-right">
                            <p>
                                Advertising is a required activity for every industry. In today's
                                world, Mobile Phone usage is fully adopted. It's extremely rare to
                                locate a technology that is so all pervasive, so wide reaching and
                                ubiquitous that it is found utilized in your local small business to
                                even that of the Presidential office.
                            </p>

                            <p>
                                However, what is little noticed is the fundamental patented technology
                                that underlies and enabled advertisers to run the now-ubiquitous
                                "call-to-action" mobile ad campaigns.
                            </p>

                            <div className="highlight-box" data-aos="zoom-in">
                                <i className="fas fa-quote-left"></i>
                                <p>
                                    Our patented technology makes it super easy for your company to
                                    create TCPA-compliant ad campaigns delivered right to users'
                                    mobile phones.
                                </p>

                                <div className="highlight-author">
                                    <strong>Kenneth O'Hanlon</strong>
                                    <span>Patent Inventor</span>
                                </div>
                            </div>

                            <p>
                                Ask-Jeeves ensures reliable, fast TCPA-compliant delivery of relevant,
                                time-sensitive, AND PERSISTENT mobile marketing material, using the
                                communications platform with the highest open rates of all: your text
                                app.
                            </p>
                        </div>

                        <div className="intro-image" data-aos="fade-left">
                            <img
                                src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                                alt="Patent Technology"
                            />

                            <div className="image-caption">
                                <i className="fas fa-shield-alt"></i>
                                TCPA-Compliant Technology Since 2010
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Main Patent Section  */}
            <section className="main-patent-section section-container">
                <div className="contents-container">
                    <div className="patents-card featured" data-aos="fade-up">
                        <div className="patent-header">
                            <div className="patent-badges">Foundation Patent</div>
                            <div className="patent-numbers">U.S. Patent No. 7,643,821</div>
                        </div>

                        <div className="patent-content">
                            <div className="patent-info">
                                <h3>The '821 Patent</h3>
                                <p className="patent-year">Filed: 2005 • Issued: 2010</p>

                                <div className="patent-description">
                                    <p>
                                        At the foundation of our company, we wanted to make sure that we
                                        had the rights to the patent that broadly covers the Mobile
                                        Advertising space. The '821 patent is that patent that is
                                        foundational to the very infrastructure of the mobile advertising
                                        industry.
                                    </p>

                                    <p>
                                        Filed in 2005 and issued in 2010, the patent solved the
                                        technological shortcomings of the state of the art, effectively
                                        enabling advertisers to push rich digital content (e.g., pictures,
                                        audio, and video) to mobile devices in real-time. This had never
                                        been done before, and we believe that this patented technology
                                        enabled the mobile ad industry to become what it is today.
                                    </p>
                                </div>

                                <div className="patent-stats">
                                    <div className="stats">
                                        <h4>$75B</h4>
                                        <p>US Mobile Ad Spending</p>
                                    </div>

                                    <div className="stats">
                                        <h4>#1</h4>
                                        <p>Surpasses TV Advertising</p>
                                    </div>

                                    <div className="stats">
                                        <h4>15+</h4>
                                        <p>Years of Innovation</p>
                                    </div>
                                </div>
                            </div>

                            <div className="patent-visual">
                                <div className="patent-image">
                                    <img
                                        src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                                        alt="Patent Technology"
                                    />
                                </div>

                                <div className="patent-action">
                                    <Link to ={"/contact"} className="patent-btn">
                                        <i className="fas fa-file-alt"></i>
                                        Request White Paper
                                    </Link>

                                    <p className="action-note">
                                        OHanlonIP, LLC (OHIP) is the current holder of the '821 patent
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Technology Features  */}
            <section className="features-section section-container">
                <div className="content-container">
                    <div className="section-header" data-aos="fade-up">
                        <h2>Coverage, Immediacy and Innovation</h2>
                        <p>How our patented technology transformed mobile marketing</p>
                    </div>

                    <div className="features-grid">
                        <div className="feature-card" data-aos="fade-up" data-aos-delay="100">
                            <div className="feature-icon">
                                <i className="fas fa-broadcast-tower"></i>
                            </div>
                            <h3>SMS Interoperability</h3>
                            <p>
                                The '821 patent covers the process of sending multi-media-capable
                                (MMS) content to requesting mobile phones, where requests are
                                generated from mobile users perceiving ads.
                            </p>
                        </div>

                        <div className="feature-card" data-aos="fade-up" data-aos-delay="200">
                            <div className="feature-icon">
                                <i className="fas fa-bolt"></i>
                            </div>
                            <h3>SMS Fast-Pull Technology</h3>
                            <p>
                                All modern SMS-based advertising platforms utilize the novel
                                combination of wireless communications technologies disclosed by our
                                patents.
                            </p>
                        </div>

                        <div className="feature-card" data-aos="fade-up" data-aos-delay="300">
                            <div className="feature-icon">
                                <i className="fas fa-chart-line"></i>
                            </div>
                            <h3>High Conversion Rates</h3>
                            <p>
                                Text-based mobile advertising campaigns have proven to outstrip
                                success rates of other digital advertising platforms through our
                                patented technology.
                            </p>
                        </div>

                        <div className="feature-card" data-aos="fade-up" data-aos-delay="400">
                            <div className="feature-icon">
                                <i className="fas fa-shield-alt"></i>
                            </div>
                            <h3>TCPA Compliance</h3>
                            <p>
                                We're a mobile marketing company with a strong legal team ensuring
                                your company remains fully compliant with all regulations.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            {/* Patent Portfolio  */}
            <section className="portfolio-section section-container">
                <div className="contents-container">
                    <div className="section-header" data-aos="fade-up">
                        <h2>Our Patent Portfolio</h2>
                        <p>
                            Comprehensive intellectual property protection for modern communication
                            technologies
                        </p>
                    </div>

                    <div className="patents-grid">
                        {/* Patent 1 */}
                        <div className="patent-card" data-aos="fade-up" data-aos-delay="100">
                            <div className="patent-header">
                                <div className="patent-badges">Mobile Marketing</div>
                                <div className="patent-numbers">U.S. Patent #8,437,453 B2</div>
                            </div>

                            <h3>The '453 Patent</h3>

                            <p className="patent-solution">
                                Solved the problem of rigid and technically complex IVR setups by
                                providing a flexible, distributed platform that allows businesses to
                                efficiently route calls based on caller-specific identifiers.
                            </p>

                            <div className="patent-benefits">
                                <span className="benefit">Flexible Call Routing</span>
                                <span className="benefit">Reduced Technical Support</span>
                                <span className="benefit">Improved Customer Experience</span>
                            </div>
                        </div>

                        {/* Patent 2 */}
                        <div className="patent-card" data-aos="fade-up" data-aos-delay="200">
                            <div className="patent-header">
                                <div className="patent-badges">QR Technology</div>
                                <div className="patent-numbers">U.S. Patent #9,038,887 B1</div>
                            </div>

                            <h3>The '887 Patent</h3>

                            <p className="patent-solution">
                                Solved the problem of inefficient interaction between
                                physical/digital items and telephone devices by enabling
                                multi-function codes to open multiple communication channels.
                            </p>

                            <div className="patent-benefits">
                                <span className="benefit">Multi-Channel Communication</span>
                                <span className="benefit">Automated Lead Capture</span>
                                <span className="benefit">Enhanced Customer Support</span>
                            </div>
                        </div>

                        {/* Patent 3 */}
                        <div className="patent-card" data-aos="fade-up" data-aos-delay="300">
                            <div className="patent-header">
                                <div className="patent-badges">Lead Management</div>
                                <div className="patent-numbers">U.S. Patent #8,817,959 B1</div>
                            </div>

                            <h3>The '959 Patent</h3>

                            <p className="patent-solution">
                                Addressed inefficient tracking and management of customer
                                interactions by enabling customized landing pages and automated
                                recording of customer interactions.
                            </p>

                            <div className="patent-benefits">
                                <span className="benefit">Automated Lead Tracking</span>
                                <span className="benefit">Custom Landing Pages</span>
                                <span className="benefit">Actionable Analytics</span>
                            </div>
                        </div>

                        {/* Patent 4 */}
                        <div className="patent-card" data-aos="fade-up" data-aos-delay="400">
                            <div className="patent-header">
                                <div className="patent-badges">IVR Systems</div>
                                <div className="patent-numbers">U.S. Patent #8,774,371 B1</div>
                            </div>

                            <h3>The '371 Patent</h3>

                            <p className="patent-solution">
                                Solved rigid and centralized IVR setups that are difficult to
                                customize and scale by enabling flexible call routing based on
                                identifiers without technical expertise.
                            </p>

                            <div className="patent-benefits">
                                <span className="benefit">Scalable IVR Systems</span>
                                <span className="benefit">Easy Customization</span>
                                <span className="benefit">Reduced Operational Costs</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Platform Features*/}
            <section className="platform-section section-container">
                <div className="content-container">
                    <div className="section-header" data-aos="fade-up">
                        <h2>Our TextBrochure AI Platform</h2>
                        <p>Built on patented technology with modern features and compliance</p>
                    </div>

                    <div className="platform-content">
                        <div className="platform-features">
                            <div className="feature-item" data-aos="fade-right" data-aos-delay="100">
                                <div className="feature-icon">
                                    <i className="fas fa-code"></i>
                                </div>
                                <div className="feature-content">
                                    <h3>Unique In-House Customization</h3>
                                    <p>
                                        Textbrochure AI contains most modern SMS platform features, but
                                        what makes us unique is our in-house code customization team. We
                                        can create custom features and add them directly to your control
                                        panel.
                                    </p>
                                </div>
                            </div>

                            <div className="feature-item" data-aos="fade-right" data-aos-delay="200">
                                <div className="feature-icon">
                                    <i className="fas fa-gavel"></i>
                                </div>
                                <div className="feature-content">
                                    <h3>Full Legal Compliance</h3>
                                    <p>
                                        We comply with all laws, rules and regulations, with licensing
                                        agreements to ensure you're protected. Our compliance extends to
                                        patents issued by the United States Patent and Trademark Office.
                                    </p>
                                </div>
                            </div>

                            <div className="feature-item" data-aos="fade-right" data-aos-delay="300">
                                <div className="feature-icon">
                                    <i className="fas fa-sync-alt"></i>
                                </div>
                                <div className="feature-content">
                                    <h3>Seamless Migration</h3>
                                    <p>
                                        We can import your contacts and migrate your existing messages
                                        from your current provider. Our dedicated technology team will
                                        handle everything for a smooth transition.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="platform-cta" data-aos="fade-left" data-aos-delay="200">
                            <div className="cta-card">
                                <h3>Ready for a Demonstration?</h3>
                                <p>
                                    Test drive our platform and see how patented technology can
                                    transform your mobile marketing.
                                </p>

                                <div className="cta-buttons">
                                    <a href="/contact" className="cta-btn-primary">
                                        <i className="fas fa-play-circle"></i>
                                        Request Demo
                                    </a>

                                    <a href="/contact" className="cta-btn-secondary">
                                        <i className="fas fa-question-circle"></i>
                                        Ask Questions
                                    </a>
                                </div>

                                <p className="cta-note">
                                    General and legal inquiries responded within 24-48 hours
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* CTA Section  */}
            <section className="patents-cta section-container">
                <div className="content-container">
                    <div className="cta-content" >
                        <h2 className="cta-title">
                            Leverage Patented Technology for Your Business
                        </h2>

                        <p className="cta-text">
                            Join companies that benefit from our foundational patents that power
                            modern mobile marketing. Ensure compliance, increase conversions, and
                            stay ahead of the competition.
                        </p>

                        <div className="cta-buttons">
                            <a href="/contact" className="cta-btn-primary">
                                Request White Paper
                            </a>

                            <a href="/contact" className="cta-btn-secondary">
                                Schedule Consultation
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}
export default Patents;